const partnersAds1 = jQuery('.PartnersAd1')

if (partnersAds1.length !== 0) {

    const partnersAdsCards = jQuery('.PartnersAd1 li')

    const min = 1,
        max = partnersAdsCards.length,
        partnersAdsSelectedIndex = Math.floor(min + Math.random() * (max + 1 - min))

    jQuery(`.PartnersAd1 li:eq(${partnersAdsSelectedIndex - 1})`).show()

}

const partnersAds2 = jQuery('.PartnersAd2')

if (partnersAds2.length !== 0) {

    const partnersAdsCards = jQuery('.PartnersAd2 li')

    const min = 1,
        max = partnersAdsCards.length,
        partnersAdsSelectedIndex = Math.floor(min + Math.random() * (max + 1 - min))

    jQuery(`.PartnersAd2 li:eq(${partnersAdsSelectedIndex - 1})`).show()

}


// const partnersAds = jQuery('.PartnersAd');
//
//
//     const partnersAdsCards = jQuery(this).find('li');
//
//     if (partnersAdsCards.length > 0) {
//         const min = 0; // Minimum index should be 0
//         const max = partnersAdsCards.length - 1; // Maximum index should be length - 1
//         const partnersAdsSelectedIndex = Math.floor(min + Math.random() * (max - min + 1)); // Adjusted max
//
//         partnersAdsCards.hide(); // Hide all ads first
//         jQuery(partnersAdsCards[partnersAdsSelectedIndex]).show(); // Show the randomly selected ad
//     } else {
//         console.log("No partner ads found in container.");
//     }
// });
